module.exports = "pegasus_template/assets/map-bg.jpg";